'use strict';

module.exports = function isIe11(ua) {
  ua = ua || navigator.userAgent;
  return ua.indexOf('Trident/7') !== -1;
};



//////////////////
// WEBPACK FOOTER
// ./~/@braintree/browser-detection/is-ie11.js
// module id = 640
// module chunks = 0